import React, { useEffect, useRef, useState } from "react";
import * as powerbi from "powerbi-client";
import BookmarkSidebar from "../Marcador/BookmarkSidebar";

const PowerBIReport = ({ token, idReport, urlReport }) => {
  const reportContainer = useRef();
  const reportRef = useRef(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [sidebarVisible, setSidebarVisible] = useState(false); // 👈 controlar visibilidad
  const [resetDashboard, setResetDashboard] = useState(false);


  // 🔑 Refrescar token desde localStorage
  const applyLocalStorageToken = () => {
    const tokenDash = localStorage.getItem("tokenBIDash");
    if (tokenDash && reportRef.current) {
      reportRef.current.setAccessToken(tokenDash);
      console.log("🔑 Token aplicado al reporte desde localStorage");
    }
  };

// RESET
const handleResetDashboard = () => {
  if (reportContainer.current) {
    // 🔹 Crear una instancia de service para resetear
    const powerbiService = new powerbi.service.Service(
      powerbi.factories.hpmFactory,
      powerbi.factories.wpmpFactory,
      powerbi.factories.routerFactory
    );

    // 🔹 Resetear el contenedor
    powerbiService.reset(reportContainer.current);

    // 🔹 Volver a embeber el reporte
    const tokenDash = localStorage.getItem("tokenBIDash");
    const embedConfig = {
      type: "report",
      id: idReport,
      embedUrl: urlReport,
      accessToken: tokenDash,
      tokenType: powerbi.models.TokenType.Aad,
      settings: {
        panes: { filters: { visible: false }, pageNavigation: { visible: true } },
      },
    };

    reportRef.current = powerbiService.embed(reportContainer.current, embedConfig);
  }
};



  // --- Embebe el reporte ---
  useEffect(() => {
    if (!token || !idReport || !urlReport) return;

    if (reportRef.current) {
      powerbi.reset(reportContainer.current);
      reportRef.current = null;
    }

    const tokenDash = localStorage.getItem("tokenBIDash");

    const embedConfig = {
      type: "report",
      id: idReport,
      embedUrl: urlReport,
      accessToken: tokenDash,
      tokenType: powerbi.models.TokenType.Aad,
      settings: {
        panes: { filters: { visible: false }, pageNavigation: { visible: true } },
      },
    };

    const powerbiService = new powerbi.service.Service(
      powerbi.factories.hpmFactory,
      powerbi.factories.wpmpFactory,
      powerbi.factories.routerFactory
    );

    reportRef.current = powerbiService.embed(reportContainer.current, embedConfig);

    reportRef.current.on("error", (event) => {
      console.error("Error en reporte:", event.detail);
      setModalMessage(`Error en reporte: ${JSON.stringify(event.detail)}`);
      setModalVisible(true);
    });

    const interval = setInterval(() => {
      applyLocalStorageToken();
    }, 14 * 60 * 1000);

    return () => clearInterval(interval);
  }, [token, idReport, urlReport]);

  return (
    <div style={{ display: "flex", height: "72vh", width: "100vw", position: "relative" }}>
      {/* Reporte embebido */}
      <div
        ref={reportContainer}
        style={{
          flex: 1,
          height: "100%",
          width: "100%",
          transition: "margin-right 0.3s ease",
          marginRight: sidebarVisible ? "5px" : "0px",
        }}
      />

      {/* Sidebar deslizable */}
      <div
        style={{
          width: sidebarVisible ? "250px" : "0px",
          height: "100%",
          transition: "width 0.3s ease",
          overflow: "hidden",
          backgroundColor: "#f4f4f4",
          borderLeft: sidebarVisible ? "1px solid #ccc" : "none",
        }}
      >
        {sidebarVisible && <BookmarkSidebar reportRef={reportRef} onResetDashboard={handleResetDashboard} />}
      </div>

      {/* Botón toggle */}
      <button
        onClick={() => setSidebarVisible(!sidebarVisible)}
        style={{
          position: "absolute",
          top: "5px",
          right: sidebarVisible ? "70px" : "15px",
          zIndex: 1000,
          padding: "8px",
          border: "none",
          borderRadius: "4px",
          backgroundColor: "#007bff",
          color: "#fff",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.3s ease",
          flexDirection: sidebarVisible ? "row" : "column", // horizontal si abierto, vertical si cerrado
          width: sidebarVisible ? "120px" : "40px",
          height: sidebarVisible ? "40px" : "120px",
        }}
      >


        {/* Texto "Marcadores" */}
        <span
          style={{
            marginLeft: sidebarVisible ? "8px" : "0px",
            marginTop: sidebarVisible ? "0px" : "8px",
            transform: !sidebarVisible ? "rotate(90deg)" : "none",
            transition: "all 0.3s ease",
            whiteSpace: "nowrap",
          }}
        >
          Marcadores
        </span>
      </button>

      {/* Modal de errores */}
      {modalVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              textAlign: "center",
              minWidth: "300px",
            }}
          >
            <p>{modalMessage}</p>
            <button onClick={() => setModalVisible(false)}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PowerBIReport;
